var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

(function (root, factory) {
  if (typeof define === "function" && define.amd) {
    define("readmo", factory);
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory();
  } else {
    root.ReadMo = factory();
  }
})(typeof self !== "undefined" ? self : this, function () {
  var version = "0.1.1";

  function isBrowserSupported() {
    try {
      // Chromium browsers that support extensions.
      if (window.chrome) {
        return true;
      }
    } catch (e) {}

    return false;
  }

  function embed(_ref) {
    var _ref$selector = _ref.selector,
        selector = _ref$selector === void 0 ? "[data-readmoapp]" : _ref$selector,
        _ref$partner = _ref.partner,
        partner = _ref$partner === void 0 ? {} : _ref$partner,
        _ref$theme = _ref.theme,
        theme = _ref$theme === void 0 ? {} : _ref$theme,
        _ref$promptInstall = _ref.promptInstall,
        promptInstall = _ref$promptInstall === void 0 ? function (_ref2) {
      var extensionUrl = _ref2.extensionUrl;
      var confirm = window.confirm("In order to open this link you need to install the official ReadMo browser extension.\n\n" + "Do you want to go to the Chrome Web Store?");

      if (confirm) {
        window.location.href = extensionUrl;
      }
    } : _ref$promptInstall;

    if (!isBrowserSupported()) {
      return;
    }

    document.addEventListener("click", function (event) {
      var target = event.target.closest(selector);

      if (!target || !target.href) {
        return;
      }

      var isExtensionIntalled = Boolean(document.querySelector("[data-readmoappenabled]"));

      if (!isExtensionIntalled) {
        event.preventDefault();
        promptInstall({
          extensionUrl: "https://chrome.google.com/webstore/detail/readmo/ahegnannhnppgepgeekncmnofpdkjnii"
        });
        return;
      }

      event.preventDefault();
      window.dispatchEvent(new CustomEvent("ReadMo", {
        detail: {
          type: "embed",
          payload: {
            partner: _objectSpread({
              url: target.href,
              name: location.hostname,
              roundedImage: true
            }, partner),
            theme: theme,
            url: target.href
          }
        }
      }));
    });
  }

  return {
    embed: embed,
    isBrowserSupported: isBrowserSupported,
    version: version
  };
});